<script setup lang="ts">
import { usePortalBranding } from './usePortalBranding';

import LogoTemplate from './LogoTemplate.vue';

withDefaults(defineProps<{
  width?: number;
  isMark?: boolean;
}>(), {
  width: 100,
  isMark: false,
});

const { branding } = usePortalBranding();
</script>

<template lang="pug">
LogoTemplate(
  :width="width"
  :name="isMark ? branding.logo : branding.logoFull"
)
</template>
